import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "small footer text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["href"]

import { APP_SETTINGS, SERVER_DATA } from '@/aux/app_configuration';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterMessage',
  setup(__props) {

const linkToPrivacyPolicy = computed(() => {
  return `${SERVER_DATA['PUBLIC_FOLDER']}/privacy_policy/${APP_SETTINGS(
    'PRIVACY_POLICY'
  )}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "mt-4",
      innerHTML: _unref(APP_SETTINGS)('FOOTER_TEXT')
    }, null, 8, _hoisted_2),
    _createElementVNode("span", null, [
      _createTextVNode(" - "),
      _createElementVNode("a", {
        href: _unref(linkToPrivacyPolicy),
        target: "_blank"
      }, "Privacy policy", 8, _hoisted_3)
    ])
  ]))
}
}

})